import {
  UI_SET_CURRENT_PAGE,
  UI_SET_SIDEBAR_COLLAPSED,
  UI_SET_CURRENT_LOCALE,
  UI_SHOW_NOTIFICATION,
  UI_HIDE_NOTIFICATION,
  UI_SET_MODAL_OPEN,
} from "./uiTypes";

// Action Creators
export const setCurrentPage = (page) => ({
  type: UI_SET_CURRENT_PAGE,
  payload: page,
});

export const setSidebarCollapsed = (collapsed) => ({
  type: UI_SET_SIDEBAR_COLLAPSED,
  payload: collapsed,
});

export const setCurrentLocale = (locale) => ({
  type: UI_SET_CURRENT_LOCALE,
  payload: locale,
});

export const showNotification = (notification) => ({
  type: UI_SHOW_NOTIFICATION,
  payload: {
    ...notification,
    id: Date.now().toString(),
  },
});

export const hideNotification = (notificationId) => ({
  type: UI_HIDE_NOTIFICATION,
  payload: notificationId,
});
export const setModalOpen = (modalType, open, data = null) => ({
  type: UI_SET_MODAL_OPEN,
  payload: { modalType, open, data },
});

// Helper action creators
export const showSuccessNotification = (message, duration) =>
  showNotification({ type: "success", message, duration });

export const showErrorNotification = (message, duration) =>
  showNotification({ type: "error", message, duration });

export const showWarningNotification = (message, duration) =>
  showNotification({ type: "warning", message, duration });

export const showInfoNotification = (message, duration) =>
  showNotification({ type: "info", message, duration });

export const openModal =
  (modalType, data = null) =>
  (dispatch) => {
    dispatch(setModalOpen(modalType, true, data));
  };

export const closeModal = (modalType) => (dispatch) => {
  dispatch(setModalOpen(modalType, false, null));
};
